function Profile(props) {
    return (
        <div className="profileContainer">
            <img src={props.profileImage} alt="Profile" className="profileImage" />
        </div>
    );
}

export default Profile;